import React from 'react'
import HelpIcon from '@material-ui/icons/Help'
import qs from 'query-string'
import { matchPath, useLocation } from 'react-router-dom'
import clsx from 'clsx'

const pathDocumentation = {
  '/import': 'https://invintus-support.freshdesk.com/a/solutions/articles/48001168406',
  '/contentGroups': 'https://invintus-support.freshdesk.com/a/solutions/articles/48001161311',
  '/securityGroups': (props) => {
    const search = qs.parse(props.location.search)
    //tab 0 or undefined === users tab 1 === security roles
    if (search && search.tab === '1') {
      return 'https://invintus-support.freshdesk.com/a/solutions/articles/48001161305'
    } else {
      return 'https://invintus-support.freshdesk.com/a/solutions/articles/48001161307'
    }
  },
  '/manage/player': 'https://docs.invintus.com/docs/players/theming'
}

const getPathToDocumentation = (props) => {
  const location = props.location
  const pathDocKey = Object.keys(pathDocumentation).find(path => {
    // get first path that matches given location
    return !!matchPath(location.pathname, {
      path,
    })
  })
  let pathDocs
  if (pathDocKey) {
    pathDocs = pathDocumentation[pathDocKey]
  }
  if (pathDocs) {
    if (typeof pathDocs === 'string') {
      return pathDocs
    } else if (typeof pathDocs === 'function') {
      return pathDocs(props)
    }
  }
}

/**
 * gets the user location on load and provide a button to link to the documentation for that page
 * @property {string?} props.path optional path to use instead of window location path
 * @property {Object?} props.location optional location object to use instead of window location
 *    must have location.pathname and location.search properties
 * @property {string?} props.className add class to the anchor
 * @property {Object?} props.style add custom style to the anchor
 * @property {boolean} props.disabled whether to disable the anchor
 * @property {string?} props.title custom title defaults to "Open Documentation"
 */
const DocLink = (props) => {
  const { path, className, style, disabled } = props
  const location = useLocation()
  const pathDoc = path ? path : getPathToDocumentation({ location, ...props })

  const openLink = (e) => {
    e.preventDefault()
    if (disabled) return
    window.open(pathDoc, '_blank')
  }

  if (!pathDoc) return null
  return (
    <a
      style={{ ...style }}
      href={pathDoc}
      title='Open Documentation'
      onClick={openLink}
      className={clsx('help-anchor', disabled && 'disabled', className && className)}
    >
      <HelpIcon />
    </a>
  )
}

export default DocLink
